import React from 'react';
import { History } from 'lucide-react';
import { CARD, LABEL, dateTime, inr } from './shared';

const ACTION = { submitted: 'Submitted', resubmitted: 'Resubmitted', changes_requested: 'Changes requested', approved: 'Approved', brand_revised_sheet: 'Brand uploaded revised sheet' };

export const NotesCard = ({ notes, status }) => (
  <div className={`${CARD} p-5 ${status === 'changes_requested' ? 'border-[#FF451A]/40 bg-[#FF451A]/[0.03]' : ''}`} data-testid="brand-notes-card">
    <div className={LABEL}>Brand notes</div>
    <p className="text-sm whitespace-pre-wrap text-[#0F0F0F] dark:text-white" data-testid="brand-notes-text">{notes || <span className="text-[#6B6B6B]">No notes from the brand yet.</span>}</p>
  </div>
);

export const HistoryList = ({ history }) => (
  <div className={`${CARD} p-5`} data-testid="plan-history">
    <div className={`${LABEL} inline-flex items-center gap-1.5`}><History size={12} /> History</div>
    {!history?.length ? <p className="text-xs text-[#6B6B6B]">No activity yet.</p> : (
      <ol className="space-y-2.5">
        {[...history].reverse().map((h, i) => (
          <li key={i} className="text-xs text-[#4B5563] dark:text-zinc-300 flex justify-between gap-3" data-testid={`plan-history-item-${i}`}>
            <span><span className="font-semibold text-[#0F0F0F] dark:text-white">{ACTION[h.action] || h.action}</span> · {h.by_name || h.by_role} · {h.creator_count} creators · {inr(h.total_budget)}</span>
            <span className="text-[#A1A1AA] whitespace-nowrap">{dateTime(h.at)}</span>
          </li>
        ))}
      </ol>
    )}
  </div>
);
